/*
 *
 * Login constants
 *
 */

export const DEFAULT_ACTION = 'app/Login/DEFAULT_ACTION';

export const UPDATE_USERNAME = 'app/Login/UPDATE_USERNAME';

export const UPDATE_PASSWORD = 'app/Login/UPDATE_PASSWORD';

export const SUBMIT_USERNAME = 'app/Login/SUBMIT_USERNAME';
export const SUBMIT_USERNAME_SUCCESS = 'app/Login/SUBMIT_USERNAME_SUCCESS';
export const SUBMIT_USERNAME_FAILURE = 'app/Login/SUBMIT_USERNAME_FAILURE';

export const LOGIN = 'app/Login/LOGIN';
export const LOGIN_SUCCESS = 'app/Login/LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'app/Login/LOGIN_FAILURE';

export const FORGOT_PASSWORD = 'app/Login/FORGOT_PASSWORD';
export const FORGOT_PASSWORD_SUCCESS = 'app/Login/FORGOT_PASSWORD_SUCCESS';
export const FORGOT_PASSWORD_FAILURE = 'app/Login/FORGOT_PASSWORD_FAILURE';

export const GO_TO_PAGE = 'app/Login/GO_TO_PAGE';
export const BACK_TO_EMAIL = 'app/Login/BACK_TO_EMAIL';
export const RESET_STATE = 'app/Login/RESET_STATE';
export const RESET_ERROR = 'app/Login/RESET_ERROR';

export const SET_DOMAIN_AUTH_METHOD = 'app/Login/SET_DOMAIN_AUTH_METHOD';

export const REQUIRE_TWO_FA_CODE = 'app/Login/REQUIRE_TWO_FA_CODE';
export const UPDATE_TWO_FA_CODE = 'app/Login/UPDATE_TWO_FA_CODE';
export const SUBMIT_TWO_FA_CODE = 'app/Login/SUBMIT_TWO_FA_CODE';
export const SUBMIT_TWO_FA_CODE_SUCCESS =
  'app/Login/SUBMIT_TWO_FA_CODE_SUCCESS';
export const SUBMIT_TWO_FA_CODE_FAILURE =
  'app/Login/SUBMIT_TWO_FA_CODE_FAILURE';
